import { Component, Input } from '@angular/core';

export type SkeletonVariant = 'text' | 'card' | 'table-row';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss']
})
export class SkeletonComponent {
  @Input() variant: SkeletonVariant = 'text';
  @Input() lines = 3;
  @Input() rows = 3;
  @Input() columns = 4;

  get items(): unknown[] {
    const count = this.variant === 'table-row' ? this.rows : this.lines;
    return Array.from({ length: count });
  }

  get columnItems(): unknown[] {
    return Array.from({ length: this.columns });
  }
}
